"use client";

import { useSession } from "next-auth/react";
import { useEffect, useRef } from "react";

import { hydrateCartFromServer, setCartSyncUser, useCartStore } from "@/components/providers/cart-store";
import { hydrateWishlistFromServer, setWishlistSyncUser, useWishlistStore } from "@/components/providers/wishlist-store";

/** Bridges the guest (localStorage) cart/wishlist stores to the database once a session exists. */
export function CartWishlistSync() {
  const { data: session, status } = useSession();
  const hydratedFor = useRef<string | null>(null);

  useEffect(() => {
    if (status !== "authenticated" || !session?.user?.id) {
      if (hydratedFor.current || useCartStore.getState().cartOwnerId) {
        // User logged out or unauthenticated: clear in-memory stores so guest/next customer starts clean
        useCartStore.getState().clearCart();
        useWishlistStore.setState({ items: [], wishlistOwnerId: null });
        try {
          localStorage.removeItem("mova-ethiopia-cart");
          localStorage.removeItem("mova-ethiopia-wishlist");
        } catch {
          // ignore
        }
      }
      setCartSyncUser(null);
      setWishlistSyncUser(null);
      hydratedFor.current = null;
      return;
    }

    const userId = session.user.id;

    if (hydratedFor.current === userId) {
      setCartSyncUser(userId);
      setWishlistSyncUser(userId);
      return;
    }

    hydratedFor.current = userId;
    void hydrateCartFromServer(userId);
    void hydrateWishlistFromServer(userId);
  }, [status, session?.user?.id]);

  return null;
}
